import { EntityNoteHeader_PublicEntityType } from "shared/service/api/generated";
import { NoteEditor } from "./NoteEditor";

export class Note {
    public readonly id: number;
    public readonly entityType: EntityNoteHeader_PublicEntityType;
    public readonly entityId: number;
    public readonly type: string;
    public readonly contactDate: Date;
    public readonly createdBy: NoteEditor;

    constructor(id: number, entityType: EntityNoteHeader_PublicEntityType, entityId: number, type: string, contactDate: Date, createdBy: NoteEditor) {
        this.id = id;
        this.entityType = entityType;
        this.entityId = entityId;
        this.type = type;
        this.contactDate = contactDate;
        this.createdBy = createdBy;
    }

    toString() {
        const contactDay = this.contactDate.getDate();
        const contactDayAsString = contactDay < 10 ? `0${contactDay}` : contactDay;

        const contactMonth = this.contactDate.getMonth() + 1;
        const contactMonthAsString = contactMonth < 10 ? `0${contactMonth}` : contactMonth;
        return `${contactDayAsString}.${contactMonthAsString} / ${this.type} / ${this.createdBy.fullName}`;
    }
}
